exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fullpage-demo[data-v-2407d64e] {\n  background-color:yellow;\n  font-size: 2.25rem;\n  line-height: 10rem;\n  text-align: center;\n}\n", ""]);

// exports
